// reducers
import { initialState } from 'root/stores/teams/schema';
import createReducerExtended from 'utils/createReducerExtended';

import { constants } from '../constants';
import * as reduceDeactivateUser from './reduceDeactivateUser';
import * as reduceInviteTeamMember from './reduceInviteTeamMember';
import * as reduceReadTeamByOrganization from './reduceReadTeamByOrganization';
import * as reduceRemoveUsersFromBoard from './reduceRemoveUsersFromBoard';
import * as reduceUpdateTeamMember from './reduceUpdateTeamMember';

export const reducer = (state = initialState, action) =>
  createReducerExtended(state, action, constants, {
    ...reduceReadTeamByOrganization,
    ...reduceDeactivateUser,
    ...reduceInviteTeamMember,
    ...reduceUpdateTeamMember,
    ...reduceRemoveUsersFromBoard,
  });
